import React, { useState } from "react";
import styles from "../styles/noticias.module.css";

const Noticias: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={styles.pageNoticias}>
      <div className={styles.containerNoticias}>
        <h1 className={styles.tituloNoticias}>
          Mantenha-se conectado com o mundo do Vet Viajante!
        </h1>

        {/* Skeleton visível até o iframe terminar de carregar */}
        {!loaded && <div className={styles.skeleton}></div>}

        <iframe
          src="https://noticiasvetviajante.blogspot.com/"
          className={`${styles.iframeNoticias} ${!loaded ? styles.hidden : ""}`}
          title="Notícias Vet Viajante"
          aria-label="Notícias Vet Viajante"
          loading="lazy"
          onLoad={() => setLoaded(true)}
        />
      </div>
    </div>
  );
};

export default Noticias;
